import { Directive } from '@angular/core';
import {NavService} from 'shared/nav/nav.service';
import { DefaultPage } from '../default-page/default-page';
import { TranslateService } from '@ngx-translate/core';

@Directive()
export abstract class DefaultMenuPage extends DefaultPage {

  constructor(
    private __navService: NavService,
    private _translateService: TranslateService,
  ) {
    super(__navService)
  }
  
  public showSettings(): void {
    this.__navService.push('profile/settings');
  }

  public showSearch(): void {
    this.__navService.push('/search');
  }

  public showMenuEntry(label: string): boolean {
    const s = this._translateService.instant(label).trim();
    return s != '' && s.indexOf('-- ') !== 0;
  } 

}
